// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"ZakonczArkuszBtn_btn_zamknij__EPAYi"};